/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Group_Options_Create_Ad_TemplateInputs */



/**
* | output |
* | --- |
* | "Create AD Template" |
*
* @param {Event_Group_Options_Create_Ad_TemplateInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_group_options_create_ad_template = /** @type {((inputs?: Event_Group_Options_Create_Ad_TemplateInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Group_Options_Create_Ad_TemplateInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Créer un modèle de description audio")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Vorlage erstellen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Crea modello di annuncio")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Создать шаблон объявления")
	if (locale === "es") return /** @type {LocalizedString} */ ("Crear plantilla de AD")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("创建 AD 模板")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADテンプレートを作成する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("AD टेम्पलेट बनाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Criar modelo de anúncio")
	return /** @type {LocalizedString} */ ("Create AD Template")
});